new ScrollHint('.js-scrollable', {
  applyToParents: true,
  remainingTime: 5000,
  i18n: {
      scrollable: 'スクロールできます'
  }
});